module.exports = __webpack_public_path__ + "img/star.eb4d131c.webp";